<template>
  <!-- 忘记密码弹窗 -->
  <el-dialog
    v-model="visible"
    title="忘记密码"
    width="440px"
    :close-on-click-modal="true"
    :close-on-press-escape="true"
    :show-close="true"
    custom-class="login-dialog"
    @closed="onDialogClosed"
    @opened="onDialogOpened"
  >
    <div class="login-box">
      <div class="login-header">
        <div class="logo-container">
          <img src="/logo-jbh.png" alt="简单画素材网" class="logo">
        </div>
        <h2>忘记密码</h2>
      </div>
      <el-form :model="passwordForm" 
              :rules="rules"
              @submit.prevent class="login-form">
        <el-form-item prop="username">
          <el-input 
            v-model="passwordForm.username" 
            placeholder="请输入用户名"
            :disabled="loading"
          >
            <template #prefix>
              <el-icon><User /></el-icon>
            </template>
          </el-input>
        </el-form-item>
        <!-- <el-form-item prop="verifyCode">
          <el-input 
            v-model="passwordForm.verifyCode" 
            placeholder="请输入验证码"
            :disabled="loading"
          >
            <template #prefix>
              <el-icon><Warning /></el-icon>
            </template>
            <template #suffix>
              <el-button 
                type="text" 
                size="small" 
                :disabled="countdown > 0"
                @click="sendVerifyCode"
              >
                {{ countdown > 0 ? `${countdown}秒后重试` : '获取验证码' }}
              </el-button>
            </template>
          </el-input>
        </el-form-item> -->
        <el-form-item prop="newPassword">
          <el-input 
            v-model="passwordForm.newPassword" 
            :type="passwordVisible ? 'text' : 'password'" 
            placeholder="请输入新密码"
            :disabled="loading"
          >
            <template #prefix>
              <el-icon><Lock /></el-icon>
            </template>
            <template #suffix>
              <el-icon class="password-icon" @click="passwordVisible = !passwordVisible">
                <component :is="passwordVisible ? 'View' : 'Hide'" />
              </el-icon>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="confirmPassword">
          <el-input 
            v-model="passwordForm.confirmPassword" 
            :type="passwordVisible ? 'text' : 'password'" 
            placeholder="请再次输入新密码"
            :disabled="loading"
          >
            <template #prefix>
              <el-icon><Lock /></el-icon>
            </template>
            <template #suffix>
              <el-icon class="password-icon" @click="passwordVisible = !passwordVisible">
                <component :is="passwordVisible ? 'View' : 'Hide'" />
              </el-icon>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button 
            type="primary" 
            :loading="loading"
            @click="handleResetPassword"
            class="login-button"
          >
            重置密码
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script setup>
import { ref, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { User, Lock, View, Hide, Warning } from '@element-plus/icons-vue'
import { resetPassword } from '@/api/auth'

const backendUrl = ref(import.meta.env.VITE_JAVA_API_URL)

// 定义props
const props = defineProps({
  show: {
    type: Boolean,
    default: false
  }
})

// 定义事件
const emit = defineEmits(['update:show', 'reset-success', 'reset-error'])


const rules = {
    username: [
      { required: true, message: '请输入用户名', trigger: 'blur' },
      { min: 2, max: 50, message: '用户名长度应为2-50个字符', trigger: 'blur' },
      { pattern: /^[A-Za-z0-9]+$/, message: '用户名只能包含英文字母和数字', trigger: 'blur' }
    ],
    newPassword: [
      { required: true, message: '请输入密码', trigger: 'blur' },
      { min: 8, max: 20, message: '密码长度应为8-20个字符', trigger: 'blur' },
      { 
        pattern: /^(?=.*[A-Za-z])(?=.*\d)|(?=.*[A-Za-z])(?=.*[^A-Za-z0-9])|(?=.*\d)(?=.*[^A-Za-z0-9]).{8,20}$/, 
        message: '密码必须包含英文字母、数字、符号中的至少两种组合', 
        trigger: 'blur'
      }    
    ],
    confirmPassword: [
      { required: true, message: '请再次输入密码', trigger: 'blur' },
      { min: 8, max: 20, message: '密码长度应为8-20个字符', trigger: 'blur' },
      { 
        pattern: /^(?=.*[A-Za-z])(?=.*\d)|(?=.*[A-Za-z])(?=.*[^A-Za-z0-9])|(?=.*\d)(?=.*[^A-Za-z0-9]).{8,20}$/, 
        message: '密码必须包含英文字母、数字、符号中的至少两种组合', 
        trigger: 'blur'
      }
    ]
};

// 表单数据
const passwordForm = ref({
  username: '',
  verifyCode: '',
  newPassword: '',
  confirmPassword: ''
})

const passwordVisible = ref(false)
const countdown = ref(0)
const visible = ref(false)
const loading = ref(false)

// 监听props更新本地状态
watch(() => props.show, (newVal) => {
  console.log('ForgetPasswordDialog props.show changed:', newVal)
  visible.value = newVal
  if (newVal) {
    initForm()
  }
})

// 监听本地状态更新props
watch(visible, (newVal) => {
  console.log('ForgetPasswordDialog visible changed:', newVal)
  emit('update:show', newVal)
})

// 初始化表单
const initForm = () => {
  // 可以在这里重置表单
  passwordForm.value = {
    username: '',
    verifyCode: '',
    newPassword: '',
    confirmPassword: ''
  }
  countdown.value = 0
}

// 打开对话框时的处理
const onDialogOpened = () => {
  console.log('ForgetPasswordDialog opened')
}

// 弹窗关闭时的处理
const onDialogClosed = () => {
  console.log('ForgetPasswordDialog closed')
  emit('update:show', false)
}

// // 发送验证码
// const sendVerifyCode = async () => {
//   if (!passwordForm.value.username) {
//     ElMessage.warning('请先输入用户名')
//     return
//   }
//   loading.value = true
//   try {
//     const response = await fetch(`${backendUrl.value}/system/auth/send-verify-code`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({
//         username: passwordForm.value.username
//       })
//     })
//     const data = await response.json()
//     if (!response.ok) {
//       throw new Error(data.message || '发送验证码失败')
//     }
//     ElMessage.success('验证码发送成功')
//     countdown.value = 60
//     const timer = setInterval(() => {
//       countdown.value--
//       if (countdown.value <= 0) {
//         clearInterval(timer)
//       }
//     }, 1000)
//   } catch (error) {
//     console.error('发送验证码失败:', error)
//     ElMessage.error(error.message || '发送验证码失败，请稍后重试')
//   } finally {
//     loading.value = false
//   }
// }

// 重置密码
const handleResetPassword = async () => {
  if (!passwordForm.value.username  || !passwordForm.value.newPassword || !passwordForm.value.confirmPassword) {
    ElMessage.warning('请填写完整信息')
    return
  }
  if (passwordForm.value.newPassword !== passwordForm.value.confirmPassword) {
    ElMessage.warning('两次输入的密码不一致')
    return
  }
  loading.value = true
  try {
    const response = await resetPassword({
      username: passwordForm.value.username,
      password: passwordForm.value.newPassword
    })
    if(response.data.code === 200){
      ElMessage.success('密码重置成功，请使用新密码登录')
      visible.value = false
      emit('reset-success')
    }else{
      ElMessage.error(response.data.message || '重置密码失败，请稍后重试')
      emit('reset-error', response.data.message || '重置密码失败，请稍后重试')
    }
    visible.value = false
    emit('reset-success')
  } catch (error) {
    console.error('重置密码失败:', error)
    ElMessage.error(error.message || '重置密码失败，请稍后重试')
    emit('reset-error', error.message || '重置密码失败，请稍后重试')
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
/* 自定义对话框样式 */
:deep(.login-dialog) {
  border-radius: 12px;
  overflow: hidden;
  padding: 0;
}

:deep(.el-dialog__body) {
  padding: 30px;
  background-color: white;
}

.login-box {
  position: relative;
  z-index: 1;
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.logo-container {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}

.logo {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: white;
}

.login-header h2 {
  margin: 0;
  color: #333;
  font-size: 24px;
  font-weight: 600;
}

.login-form {
  padding: 10px 0;
}

:deep(.el-input) {
  --el-input-height: 40px;
  margin-bottom: 20px;
}

:deep(.el-input__wrapper) {
  border-radius: 20px;
  border: 1px solid #ddd;
  box-shadow: none;
  transition: all 0.3s ease;
}

:deep(.el-input__wrapper:hover) {
  border-color: #6a11cb;
  box-shadow: 0 0 0 2px rgba(106, 17, 203, 0.1);
}

:deep(.el-input__wrapper.is-focus) {
  border-color: #6a11cb;
  box-shadow: 0 0 0 2px rgba(106, 17, 203, 0.2);
}

:deep(.el-input__placeholder) {
  color: #999;
}

.password-icon {
  cursor: pointer;
  font-size: 16px;
  color: #909399;
}

/* 减小el-form-item之间的间距 */


.login-button {
  width: 100%;
  height: 44px;
  border-radius: 22px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
  background: linear-gradient(135deg, #3344FF 0%, #8800FF 100%);
  border: none;
  color: white;
  box-shadow: 0 4px 12px rgba(51, 68, 255, 0.3);
  transition: all 0.3s ease;
}

.login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(51, 68, 255, 0.4);
  background: linear-gradient(135deg, #5566FF 0%, #AA00FF 100%);
}

.login-button:disabled {
  box-shadow: none;
  transform: none;
}

/* 响应式调整 */
@media (max-width: 480px) {
  :deep(.el-dialog) {
    width: 90% !important;
    margin: 0 auto !important;
  }
  
  :deep(.el-dialog__body) {
    padding: 20px;
  }
  
  .logo {
    width: 60px;
    height: 60px;
  }
  
  .login-header h2 {
    font-size: 20px;
  }
  
  .login-button {
    height: 40px;
    font-size: 14px;
  }
}
</style>